import './About.scss'
import { motion } from 'framer-motion'


const About = () => {
  return (
    <div className='about' id='about'>
      <h1>About me</h1>
      <div className='aboutContainer'>
        <motion.div
          whileInView={{ y: [-100, 0], opacity: [0, 1] }}
          transition={{ duration: 1 }}
          className='left'
        >
          <div className='wrapper'>
            
            <p style={{paddingLeft: "25px", paddingRight: '25px'}}><br/>
                I am an executive with 15+ years of experience in corporate field. 
                I started my career back in 2007, where I was Authorized Representative for AB & Company Ltd,
                since then I've worked with several renowned companies according to my area of expertise. <br/>
                Currently, I'm a Senior Officer & Branch In-Charge of Nikunja Branch for ONE Securities Ltd. <br/>
                Apart from a successful corporate career, I am also a stock broker.
                
            </p>
          </div>
        </motion.div>
        <motion.div
          whileInView={{ y: [100, 0], opacity: [0, 1] }}
          transition={{ duration: 1 }}
          className='right'
        >
          <div className='imgContainer1'>
            <img src='Assets/about1.jpg' alt='' />
          </div>
          <div className='imgContainer2'>
            <img src='Assets/about2.jpg' alt='' />
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default About
